export default __webpack_public_path__ + "static/wamo-mic-mobile-b0899478ee51fcca653dffbbdc773c67.jpg";